import {
	CURR_PREVIEW_ID,
	CURR_PREVIEW_TYPE,
	PREVIEW_TYPE_CONFIG,
} from "../conf";

const getRemoteOptions = () => {
	// Extend the function to return correct API options
	// for various types of previews
	// For now, it returns just the complete API options (/core/push/)
	if (!PREVIEW_TYPE_CONFIG[CURR_PREVIEW_TYPE]) return {};

	// module_type: "survey",
	// module_id: "84f69a9c-d5d8-4839-80c6-5114839f964b",
	return {
		url: PREVIEW_TYPE_CONFIG[CURR_PREVIEW_TYPE].url,
		method: "POST",
		data: {
			platform: true,
			module_type: CURR_PREVIEW_TYPE,
			module_id: CURR_PREVIEW_ID,
			...PREVIEW_TYPE_CONFIG[CURR_PREVIEW_TYPE].remoteData,
		},
	};
};

export default getRemoteOptions;
